// lessons/les1-motiverende-gespreksvoering/modules/Module5.js
export const MODULE5_CONFIG = {
    id: 'module5',
    title: 'Reflecteren op Verandertaal',
    type: 'conversation',
    duration: 65,
    
    theory: {
      title: 'Reflecteren op verandertaal',
      sections: [
        {
          id: 'gericht-reflecteren',
          title: 'Gericht reflecteren',
          content: `Met open vragen en reflecties geef je meer diepgang aan het gesprek. De cliënt kan daarbij zowel verandertaal als behoudtaal uitspreken. Door vooral te reflecteren op de verandertaal, nodig je de cliënt uit om dit verder te verkennen en vaker te benoemen. Zo kun je met gerichte reflecties het gesprek in een positieve richting sturen, terwijl de motivatie en drijfveren van de cliënt steeds het uitgangspunt blijven.

Lees onderstaand voorbeeld om te zien hoe dit er in de praktijk aan toe kan gaan:

Cliënt:

"Ja, ik wil die oefeningen echt vaker doen, want ik merk dat mijn rug soepeler wordt als ik ze regelmatig doe. Maar op dagen dat ik veel werk heb, vergeet ik het gewoon."

Oefentherapeut:

"U merkt dat uw rug soepeler wordt als u de oefeningen doet."

De oefentherapeut kiest in het voorbeeld bewust om op verandertaal te reflecteren om de kans te vergroten dat de cliënt juist de voordelen van de gedragsverandering verder gaat verdiepen. In de praktijk gaat er vaak een langer gesprek aan vooraf waarbij zowel de voor- als nadelen van verandering worden besproken. Jij kan als behandelaar uiteindelijk wel de richting bepalen door goed te luisteren, de verandertaal er uit te pikken en daarop te reflecteren.`
        },
         {
        id: 'bronnen',
        title: 'Optionele bronnen',
        content: `Wil je meer weten over reflecteren op verandertaal? Bekijk dan onderstaande bron!
        
        Ontlokken
https://www.youtube.com/watch?v=hypyR3EaEUY&t=11s
Bekijk het fragment “2C Ontlokken (MGV-trouw)” van MINTned op YouTube. Hier zie je hoe de hulpverlener verandertaal herkent, uitlokt en daarop reflecteert tijdens een gesprek.
Kijktijd: 8 minuten`
      },
       {
          id: 'introductie opdracht',
          title: 'Introductie Opdracht',
          content: `**Uitleg**
          
      In de volgende simulatiegesprekken ga je oefenen met reflecteren op verandertaal. Je hebt de opdracht behaald wanneer je vijf keer op verandertaal hebt gereageerd met een reflectie.

Je spreekt eerst met Sanne en vervolgens met Peter.

**Tips**

Maak gebruik van alle technieken die je hebt geleerd om het gesprek te verdiepen en verandertaal te ontlokken.

Je hebt nu al wat ervaring met de simulatiegesprekken, probeer eens wat sneller te reageren om meer in een natuurlijke gespreksflow te komen.

          `
        }

      ]
    },
  
    conversations: {
      total: 2,
      passingCriteria: 'In een simulatiegesprek vijf keer reageren op verandertaal met een reflectie.',
      requiredChangeTalkReflections: 5,
      
      instruction: `In deze trainingssessie oefen je met reflecteren op verandertaal. Luister goed naar je cliënt, en pik verandertaal er uit om juist daarop te reflecteren. Je hebt de opdracht behaald als je vijf keer specifiek op verandertaal hebt gereflecteerd. Je kan zowel complexe als eenvoudige reflecties inzetten om het gesprek over verandertaal te verdiepen.`,

      afterConversation1: `Goed gedaan! Je hebt vijf keer specifiek op verandertaal gereflecteerd. Lees nu onderstaande feedback op jouw gesprekstechnieken, en probeer nog effectiever te reflecteren in de tweede ronde!

Tip: schrijf op welke feedback jij nuttig vindt om mee te nemen in het volgende simulatiegesprek!`,

      afterConversation2: `Goed gedaan! Je hebt vijf keer specifiek op verandertaal gereflecteerd. Je hebt dus het leerdoel van deze module behaald. Lees onderstaande feedback en ga vervolgens verder met de volgende module waarin je alle technieken laat samenkomen.

Tip: schrijf op welke feedback jij nuttig vindt om toe te passen in jouw praktijk als behandelaar!`
    },
  
    completionCriteria: {
      type: 'conversation_evaluation',

      requiredConversations: 2,
      requiredChangeTalkReflections: 5,
      description: 'Beide gesprekken succesvol afgerond met minimaal 5 reflecties op verandertaal per gesprek'
    }
  };
  
  export default MODULE5_CONFIG;